var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ComponentContext } from '../../Context/ComponentContext';
import { ReduxContext } from '../../Context/ReduxContext';
import { UsageHelper } from '../../Models/UsageTelemetry';
export class ComponentProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            Component: null,
            hasError: false,
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.config.common) {
                this.context.componentLoader
                    .loadCommon(this.props.config.common)
                    .then(() => {
                    setTimeout(() => {
                        this.loadComponent().catch();
                    }, Math.random() * 1000);
                });
            }
            else {
                this.loadComponent().catch();
            }
        });
    }
    componentDidUpdate(prevProps) {
        return __awaiter(this, void 0, void 0, function* () {
            const { config } = prevProps;
            if (this.shouldReload(config))
                yield this.loadComponent();
        });
    }
    componentDidCatch(error, errorInfo) {
        this.context.telemetryClient.trackException({
            exception: error,
            properties: Object.assign({}, errorInfo),
        });
        console.error(error, errorInfo);
        this.setState({ hasError: true });
    }
    render() {
        const _a = this.props, { renderError, renderPlaceholder, config } = _a, otherProps = __rest(_a, ["renderError", "renderPlaceholder", "config"]);
        const { Component, hasError } = this.state;
        const newTelemetryContext = this.getChildTelemetryContext(config);
        const newTelemetryClient = this.context.telemetryClient.getChildInstance();
        const newHttpClient = this.context.httpClient.getChildInstance(newTelemetryClient, this.context.authClient);
        newTelemetryClient.setContext(newTelemetryContext);
        const newContext = Object.assign(Object.assign({}, this.context), { id: config.id || config.name, telemetryContext: newTelemetryContext, telemetryClient: newTelemetryClient, httpClient: newHttpClient });
        if (hasError)
            return renderError ? renderError() : null;
        if (!Component)
            return renderPlaceholder ? renderPlaceholder() : null;
        return (React.createElement(ReduxContext.Consumer, null, (reduxContext) => (React.createElement(Component, Object.assign({ context: newContext, reduxContext: reduxContext, config: config }, otherProps)))));
    }
    getChildTelemetryContext(config) {
        var _a, _b, _c;
        if (this.context.telemetryContext) {
            return (_a = this.context.telemetryContext) === null || _a === void 0 ? void 0 : _a.getChildContext((_b = config.usageFeatureName) !== null && _b !== void 0 ? _b : config.name, config.script);
        }
        else {
            // Fallback to the default UsageHelper and fork a childContext instance
            const newUsageHelper = UsageHelper.Fork((_c = config.usageFeatureName) !== null && _c !== void 0 ? _c : config.name);
            return {
                sourceComponent: config.name,
                sourceScript: config.script,
                setUsageEvent: newUsageHelper.MassageEvent,
                setUsageUser: (usageUser) => {
                    newUsageHelper.SetUser(usageUser);
                    return usageUser;
                },
                usageUser: newUsageHelper.GetUser,
                setUsageConfig: newUsageHelper.SetUsageConfig,
                getChildContext: newUsageHelper.ForkTelemetryContext,
            };
        }
    }
    shouldReload(prevConfig) {
        const { config } = this.props;
        return (prevConfig.name !== config.name ||
            prevConfig.script !== config.script);
    }
    loadComponent() {
        return __awaiter(this, void 0, void 0, function* () {
            const { config, resource, scopes } = this.props;
            const { componentLoader } = this.context;
            try {
                let Component = null;
                if (resource || scopes) {
                    Component = yield componentLoader.loadSecured(config, (resource || scopes));
                }
                else {
                    Component = yield componentLoader.load(config);
                }
                this.setState({ Component, hasError: false });
            }
            catch (e) {
                console.error(e);
                this.context.telemetryClient.trackException({
                    exception: e,
                });
                this.setState({ hasError: true });
            }
        });
    }
}
ComponentProvider.contextType = ComponentContext;
//# sourceMappingURL=ComponentProvider.js.map